import { IModel } from 'app/model/base/annotation';
import { } from '../base/annotation';
import { Metamodel } from 'app/model/base/model';
import { LinkedService } from '../linkedservice/linkedservice';

import { AzureKeyVault } from './key-vault';
import { validateAKVLinkedserviceReference } from 'app/shared/utils/linkedservice-validation-util';
import { format } from 'app/shared/utils/string.util';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';

@Metamodel.model({
    name: adfModelTypeMap.kusto.linkedServiceType,
    display: [
        format(stringResources.ModelName_LinkedServiceTemplate, stringResources.Kusto_DisplayText),
        format(stringResources.ModelName_LinkedServicesTemplate, stringResources.Kusto_DisplayText)
    ]
})
export class KustoLinkedService extends LinkedService {

    public static readonly MODEL: IModel;

    @Metamodel.attribute({
        display: stringResources.ModelName_Endpoint
    })
    public endpoint?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_ServicePrincipalID
    })
    public servicePrincipalId?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_ServicePrincipalKey,
        constraint: {
            validator: validateAKVLinkedserviceReference
        }
    })
    public servicePrincipalKey?: string | AzureKeyVault;

    constructor(name?: string, description?: string) {
        super(name, description);
    }
}
